module.exports = __webpack_public_path__ + "img/bg_logo.5fce849e.jpg";